import React, {useState} from 'react'
import LoginForm from "components/forms/LoginForm"
import useClient from "hooks/useClient";
import { useNavigate } from "react-router-dom";
import useSnackMsg from "hooks/useSnackMsg";


const Login = () => {

const [loader, setLoader] = useState(false)
const { api } = useClient();
const navigate = useNavigate();
const { eSnack } = useSnackMsg();

const handleLogin = async (payload) => {
  try {
    setLoader(true);

    const response = await api.post(`/auth/login-admin`, payload);

    setLoader(false);

    const { data } = response;

    // Validate response structure
    if (!data || !data.status_code) {
      eSnack('Invalid response from the server.');
      return;
    }

    if (data.status_code !== 200) {
      eSnack(data.detail || 'An error occurred.');
      return;
    }

    const { detail } = data;

    if (detail && detail.access_token) {
      // Save access token to localStorage with a key
      localStorage.setItem('jwt', detail.access_token);
      navigate("/");
    } else {
      eSnack('Access token not found.');
    }
  } catch (error) {
    setLoader(false);

    // Log the error and show a user-friendly message
    console.error('Error during login:', error);
    eSnack('Sorry, something went wrong. Please try again.');
  }
};


  return (
    <div className='w-full min-h-screen max-h-screen bg-[#121212] flex justify-center items-center'>
      <div className='bg-[#1E1E1E] md:w-[50%] min-h-[50%] md:p-10 sm:p-5 xs:p-3  rounded-xl sm:w-[90%] xs:w-[90%]'>
      <div className='flex justify-center mb-10'>
      <img alt="logo" src="/logo-wide.png" className='w-[220px]'/>
      </div>
      <LoginForm loader={loader} handleLogin={handleLogin}/>  
      </div>
    </div>
  )
}

export default Login
